/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const CommerceChannelsContext = createContext({
  fetchCommerceChannel: () => {}
})

export default CommerceChannelsContext
